



























import Vue, { PropType } from 'vue'
import { NewsItem as NewsItemInterface } from '../../../base/store/state.interface'
import { Widget } from '../base'
import MessagesWidgetAlarmItem from './MessagesWidgetAlarmItem.vue'
import MessagesWidgetEventsItem from './MessagesWidgetEventsItem.vue'
import MessagesWidgetNewsItem from './MessagesWidgetNewsItem.vue'
import NoWidgetAccess from '../../components/NoWidgetAccess.vue'

export default Vue.extend({
  components: {
    MessagesWidgetAlarmItem,
    MessagesWidgetEventsItem,
    MessagesWidgetNewsItem,
    NoWidgetAccess
  },
  props: {
    widget: {
      type: Object as PropType<Widget>,
      required: true
    }
  },
  data() {
    return {
      firstAlarmId: 0
    }
  },
  computed: {
    showTitle() {
      return this.widget?.customSettings?.settings.showTitle.checked
    },
    layoutVertical() {
      return this.widget?.customSettings?.settings.layoutVertical.checked
    },
    filteredItems(): NewsItemInterface[] {
      let items: any[] = []
      const customSettings = this.widget.customSettings ? this.widget.customSettings.settings : undefined
      const hasCustomSettings = !!customSettings

      // is "Alarmierungen" checked?
      if (hasCustomSettings && customSettings.alarms.checked) {
        const alarms = this.getSortedItemsFromState(this.$store.state.alarm, 'alarm')
        this.firstAlarmId = 0
        if (alarms.length) {
          this.firstAlarmId = alarms[0].id
          items = items.concat(alarms)
        }
      }

      // is "Mitteilungen anzeigen" checked?
      if (hasCustomSettings && customSettings.message.checked) {
        const news = this.getSortedItemsFromState(this.$store.state.news, 'news')
        if (news.length) {
          items = items.concat(news)
        }
      }

      // is "Termine anzeigen" checked?
      if (hasCustomSettings && customSettings.news.checked) {
        const events = this.getSortedItemsFromState(this.$store.state.events, 'events', 'start')
        if (events.length) {
          items = items.concat(events)
        }
      }

      // is "Empfänger -> Bestimmte Gruppen" selected?
      if (
        hasCustomSettings &&
        customSettings.recipients.data &&
        (customSettings.recipients.data.notification_type === '3')
      ) {
        const groups = customSettings.recipients.data.usingGroups
        items = items.filter(item => (item.notification_type === 2) || item.group.filter(x => groups.includes(x)).length > 0)
      }

      items.sort((a, b) => {
        if (b.__type === a.__type) {
          return 0
        }
        return b.__ts - a.__ts
      })

      return items
    },
    numItems(): number {
      return this.filteredItems ? this.filteredItems.length : 0
    }
  },
  methods: {
    getSortedItemsFromState(state, itemType, timestampFieldName = 'date'): NewsItemInterface[] {
      if (!state) return []

      const rawItems = state.items

      return state.sorting.map((id: number  | string) => {
        const item = JSON.parse(JSON.stringify(rawItems[id]))

        if (!item) return

        item.__type = itemType
        item.__ts = item[timestampFieldName]

        return item
      }).filter((item: NewsItemInterface) => {
        return !!item && item.cluster_id === this.$store.getters.getCurrentClusterId
      })
    }
  }
})
